import { otherViewFilterText } from 'owa-locstrings/lib/strings/otherviewfiltertext.locstring.json';
import { focusedViewFilterText } from 'owa-locstrings/lib/strings/focusedviewfiltertext.locstring.json';
import { searchFolderName } from 'owa-locstrings/lib/strings/searchfoldername.locstring.json';
import loc from 'owa-localize';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import { TableQueryType } from 'owa-mail-list-store';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import getInboxPlusPivotDisplayProperties from 'owa-mail-inbox-plus-store/lib/selectors/getInboxPlusPivotDisplayProperties';
import { isInboxPlusEnabled } from 'owa-inbox-plus-util/lib/util/inboxPlusFlightUtil';

/**
 * Get the folder scope text
 * @param focusedViewFilter the focused view filter
 * @param inboxClassificationFilter the inbox classification filter
 * @param tableQueryType the table query type (mail, group, search)
 * @param folderDisplayName display name of the folder on which the action is taken
 * @returns the folder scope text, e.g Focused Inbox, Other Inbox, Sent Items, etc.
 */
export default function getFolderScopeText(
    focusedViewFilter: FocusedViewFilter,
    inboxClassificationFilter: InboxClassificationFilter,
    tableQueryType: TableQueryType,
    folderDisplayName: string
): string {
    if (tableQueryType === TableQueryType.Search) {
        return loc(searchFolderName);
    }
    if (isInboxPlusEnabled() && inboxClassificationFilter !== InboxClassificationFilter.None) {
        return getInboxPlusPivotDisplayProperties(inboxClassificationFilter).displayText;
    }
    switch (focusedViewFilter) {
        case FocusedViewFilter.Focused:
            return loc(focusedViewFilterText);
        case FocusedViewFilter.Other:
            return loc(otherViewFilterText);
    }
    return folderDisplayName;
}
